<template>
    <div class="import-ksxx-excel-container">
        <div class="card-container">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>本页用于在详细的 DBF 材料到货前，先导入<strong>打印和邮寄通知书所需的最小字段</strong></li>
                        <li>只支持 <strong>.xls</strong> 格式（Excel 97-2003 工作簿）。如果文件是 .xlsx，请用 Excel 另存为 .xls 后再上传</li>
                        <li>必须包含以下列（列名需完全一致）：<br />
                            层次代码、层次名称、报名号、民族、性别、政治面貌、姓名、身份证号、收件人手机号、收件人姓名、收件人详细地址、批次、专业名称、录取院系、学制</li>
                        <li>年份和院校由当前登录账号决定；省份由<strong>报名号</strong>自动提取</li>
                        <li>导入时会按"学制 → 录取院系 → 专业 → 报名号"排序，并自动生成<strong>录取号</strong>，规则与导入 DBF 数据完全一致</li>
                        <li>报名号已存在的考生会被跳过，不会重复导入，也不会覆盖已有数据</li>
                        <li>建议把「报名号」「身份证号」「收件人手机号」列在 Excel 中设为<strong>文本格式</strong>，避免变成科学计数法</li>
                    </ul>
                    <p style="margin-top: 8px;">
                        <el-button type="text" icon="el-icon-download" @click="handleDownloadTemplate">下载导入模板</el-button>
                    </p>
                </div>
            </div>

            <validation-observer v-slot="{ invalid }">
                <el-form :model="form" label-width="120px" class="import-form">
                    <el-form-item label="考生信息Excel">
                        <validation-provider rules="required" tag="div" v-slot="{ errors, validate }" name="考生信息Excel">
                            <el-upload
                                class="upload-demo"
                                action="#"
                                :auto-upload="false"
                                :on-change="(file) => handleFileChange(file, validate)"
                                :on-remove="handleFileRemove"
                                :on-exceed="handleFileExceed"
                                :file-list="fileList"
                                accept=".xls"
                                :limit="1">
                                <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传 .xls 文件。再次选择会替换当前文件。</div>
                            </el-upload>
                            <span class="error-text" v-if="errors[0]">{{ errors[0] }}</span>
                        </validation-provider>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" :disabled="invalid || !uploadFile || submitting" :loading="submitting">
                            <span v-if="!submitting">开始导入</span>
                            <span v-else>导入中...</span>
                        </el-button>
                        <el-button @click="handleReset">重置</el-button>
                    </el-form-item>
                </el-form>
            </validation-observer>

            <!-- 结果显示 -->
            <div v-if="result" class="result-container">
                <el-divider>导入结果</el-divider>
                <div v-html="result" class="result-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: 'ImportKsxxExcel',
    inject: ['Loading', 'LoadingCompleted', 'getCurrentYear'],
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form: {},
            fileList: [],
            uploadFile: null,
            submitting: false,
            result: ''
        };
    },
    methods: {
        handleDownloadTemplate() {
            window.open('/GXZS/Template/v1考生信息导入模板.xls', '_blank');
        },
        handleFileChange(file, validate) {
            // 清空旧文件列表，确保只保留新选择的文件
            this.fileList = [];
            this.uploadFile = file.raw;
            this.fileList = [file];
            validate(file);
        },
        handleFileRemove() {
            this.uploadFile = null;
            this.fileList = [];
        },
        handleFileExceed(files) {
            // 当选择新文件超过限制时，替换原有文件
            this.fileList = [];
            this.$nextTick(() => {
                this.uploadFile = files[0];
                this.fileList = [{ name: files[0].name, raw: files[0] }];
            });
        },
        handleSubmit() {
            if (!this.uploadFile) {
                this.$message.warning('请选择要上传的文件');
                return;
            }

            const fileName = this.uploadFile.name || '';
            if (fileName.toLowerCase().lastIndexOf('.xls') !== fileName.length - 4) {
                this.$message.warning('只支持 .xls 格式，请用 Excel 另存为 .xls 后再上传');
                return;
            }

            this.submitting = true;
            const api_name = '/Data/ImportKsxxExcel';
            // 拼接 year 参数以确保后端 Session 更新
            const year = this.$root.currentYear || '';
            const url = TYBM_Env.GetApiUrl(api_name) + (year ? '?year=' + year : '');

            const data = {
                Model: JSON.stringify(this.form),
                ExcelFile: this.uploadFile
            };

            TYBM_Tools.AxiosUploadFile(this, api_name, url, data, { loading_msg: '正在导入考生信息', has_progress: true })
                .then(result => {
                    this.$message.success('导入成功');
                    this.result = result.data.Msg || '导入完成';
                })
                .catch(() => {
                    this.$message.error('导入失败');
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleReset() {
            this.fileList = [];
            this.uploadFile = null;
            this.result = '';
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
.import-ksxx-excel-container {
    max-width: 900px;
}

.import-form {
    margin-top: 24px;
}

.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid;
    background-color: #e6f7ff;
    border-color: #1890ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
    padding: 0;
}

.info-box li {
    margin: 4px 0;
}

.error-text {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    display: block;
}

.result-container {
    margin-top: 24px;
}

.result-content {
    padding: 16px;
    background-color: #f5f7fa;
    border-radius: 4px;
    min-height: 100px;
}

/* 隐藏el-upload的原生input */
.import-form >>> .el-upload {
    display: inline-block;
}

.import-form >>> .el-upload input[type="file"] {
    display: none !important;
}
</style>
